export interface StatusUpdateCardProps {
  title: string;
  stage: 'not-started' | 'awaiting-input' | 'working' | 'complete';
  message: string;
  className?: string;
}

import { Badge } from './Badge';

const STAGE_LABELS: Record<StatusUpdateCardProps['stage'], string> = {
  'not-started': 'Not Started',
  'awaiting-input': 'Awaiting Input',
  'working': 'Working',
  'complete': 'Complete',
};

const STAGE_BORDER: Record<StatusUpdateCardProps['stage'], string> = {
  'not-started': 'border-sd-text-muted',
  'awaiting-input': 'border-sd-warning',
  'working': 'border-sd-info',
  'complete': 'border-sd-success',
};

export function StatusUpdateCard({ title, stage, message, className = '' }: StatusUpdateCardProps) {
  return (
    <div className={`p-sd-2 rounded-sd-md bg-sd-surface-elevated border-l-2 ${STAGE_BORDER[stage]} shadow-[0_1px_2px_rgba(0,0,0,0.04)] sd-fade-in${stage === 'working' ? ' animate-pulse' : ''} motion-reduce:transition-none motion-reduce:animate-none w-full text-sd-sm ${className}`.trim()}>
      <div className="flex flex-col gap-sd-1">
        <div className="flex items-center gap-sd-2">
          <Badge variant={stage}>{STAGE_LABELS[stage]}</Badge>
          <span className="font-semibold text-sd-text">{title}</span>
        </div>
        <span className="text-sd-text-secondary leading-relaxed">{message}</span>
      </div>
    </div>
  );
}
